import store from 'meta/store'

const formattedGroups = (groups) => {
  if (!groups || typeof groups !== 'object') return {}
  return Object.keys(groups).reduce((acc, curr) => {
    acc[curr] = groups[curr]?.permissions?.map((p) => p.method) || []
    return acc
  }, {})
}

export const getUserPermissionGroups = (user) => {
  if (!user) return {}
  // super_admin and support use their own top-level groups
  if (user.role === 'super_admin' || user.role === 'support') {
    return formattedGroups(user.groups)
  }
  // all other users use the groups from the current place
  const place = store.getState().place
  const groups = place && place.place_user && place.place_user.groups
  return formattedGroups(groups)
}

// Safe permission check — returns false if group key is wrong or missing
export const hasPermission = (groupId, method) => {
  const permissionGroups = getUserPermissionGroups(store.getState().me)
  if (!permissionGroups || !groupId || !method) return false
  const methods = permissionGroups[groupId]

  return Array.isArray(methods) && methods.includes(method)
}

export const getUserRole = (user) => {
  if (!user) return null
  if (user.role === 'super_admin') return 'super_admin'
  if (user.role === 'support') return 'support'
  const place = store.getState().place
  return place && place.place_user && place.place_user.role
}

export const isSuperAdmin = (user) =>
  getUserRole(user) === 'super_admin'

export const isPlaceAdmin = (user) =>
  getUserRole(user) === 'content_admin' || getUserRole(user) === 'organization_admin'

export const isSupport = (user) =>
  getUserRole(user) === 'support'

export const isAdmin = (user) =>
  isSuperAdmin(user) || isSupport(user) || isPlaceAdmin(user)

export const isContentAdmin = (user) =>
  getUserRole(user) === 'content_admin'

export const isOrganizationAdmin = (user) =>
  getUserRole(user) === 'organization_admin'

export const isOwner = (user, source) => {
  if (!user || !source) return false
  const userId = user.id
  const sourceUserId = source.userId
  return userId === sourceUserId
}
